/** Kamus **dashboard meja**. */
export const tableId = {
  title: 'Meja',
  empty: 'Kosong',
  occupied: 'Terisi',
  heldBy: '🔒 dipegang {{name}}',
  merged: 'Digabung ke {{parent}}',
  seats: '{{n}} kursi',
  guest: 'Jumlah tamu',
  openTable: 'Buka Meja',
  enterOrder: 'Buka Pesanan',
  cancel: 'Batal',
  merge: 'Gabung',
  release: 'Lepas gabungan',
  chooseParent: 'Pilih meja induk dulu, lalu meja yang digabung',
  changeGuests: 'Ubah jumlah tamu',
  /** ⚠️ Menyebut KENAPA — pelayan sering salah ketik, dan koreksinya harus terasa wajar. */
  changeGuestsReason: 'Salah ketik jumlah tamu bisa diperbaiki di sini, tanpa membatalkan pesanan.',
  save: 'Simpan',
  loadFailed: 'Daftar meja gagal dimuat',
};

export const tableEn: typeof tableId = {
  title: 'Tables',
  empty: 'Free',
  occupied: 'Occupied',
  heldBy: '🔒 held by {{name}}',
  merged: 'Merged into {{parent}}',
  seats: '{{n}} seats',
  guest: 'Guest count',
  openTable: 'Open Table',
  enterOrder: 'Open Order',
  cancel: 'Cancel',
  merge: 'Merge',
  release: 'Release merge',
  chooseParent: 'Pick the parent table first, then the tables to merge',
  changeGuests: 'Change guest count',
  changeGuestsReason: 'A mistyped guest count can be fixed here, without voiding the order.',
  save: 'Save',
  loadFailed: 'Could not load tables',
};
